import classnames from 'classnames';
import { DatePicker } from 'antd';

import { BaseFormFieldWrapper } from '../BaseFormFieldWrapper/BaseFormFieldWrapper';
import AppConfig from '../../providers/AppConfig';
import './BaseDatePicker.scss';

const BaseDatePicker_ = (props) => {
  const { field, onBlur, handleChange, full, ...rest } = props;

  const className = classnames({
    'date-picker--full': full,
  });

  return (
    <DatePicker
      {...field}
      {...rest}
      format={AppConfig.defaultDateFormat}
      className={className}
      onBlur={onBlur}
      onChange={handleChange}
    />
  );
};

export const BaseDatePicker = BaseFormFieldWrapper(BaseDatePicker_);
export default BaseDatePicker;
